import { RevenueData } from "../../../../types/api/dashboard";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const RevenueChart = ({revenueData} : {revenueData: RevenueData[]}) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={revenueData}>
        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="#f1f5f9"
        />

        <XAxis
          dataKey="month"
          tick={{ fontSize: 12 }}
          axisLine={false}
          tickLine={false}
        />

        <YAxis
          tick={{ fontSize: 12 }}
          axisLine={false}
          tickLine={false}
          tickFormatter={(value) => `£${(Number(value) / 1000).toFixed(1)}k`}
        />

        <Tooltip formatter={(value: any) => [`£${Number(value).toLocaleString("en-GB", { minimumFractionDigits: 2 })}`, "Revenue"]} />

        <Bar
          dataKey="revenue"
          fill="var(--color-primary)"
          radius={[6, 6, 0, 0]}
          name="Revenue"
        />

<Legend wrapperStyle={{ fontSize: "11px" }} />
      </BarChart>
    </ResponsiveContainer>
  );
};


export default RevenueChart